import {
  useConnectionState,
  useLocalParticipant,
  useMediaDeviceSelect,
} from '@livekit/components-react';
import { MediaDeviceType, useMediaDevice } from '@sunrise-ui/primitives';
import { ConnectionState } from 'livekit-client';
import { useEffect } from 'react';

export function useSyncMediaDeviceWithLiveKit(
  mediaDeviceType: MediaDeviceType,
) {
  const { deviceId } = useMediaDevice(mediaDeviceType);
  const connectionState = useConnectionState();
  const livekitDeviceKind =
    mediaDeviceType === MediaDeviceType.CAMERA ? 'videoinput' : 'audioinput';
  const { localParticipant } = useLocalParticipant();
  const hasPublishedTracks =
    localParticipant.getTrackPublications().length >= 2;

  const { devices, activeDeviceId, setActiveMediaDevice } =
    useMediaDeviceSelect({
      kind: livekitDeviceKind,
    });

  useEffect(() => {
    if (
      devices.length &&
      deviceId !== activeDeviceId &&
      hasPublishedTracks &&
      connectionState === ConnectionState.Connected
    ) {
      void setActiveMediaDevice(deviceId);
    }
  }, [
    devices,
    deviceId,
    setActiveMediaDevice,
    activeDeviceId,
    connectionState,
  ]);
}
